import { styled } from "../../Theme";
import { ButtonPill } from "../../components";

export const FinalQuizContainer = styled.div`
  width: 100%;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  .question-media-container {
    box-sizing: border-box;
  }
`;

export const QuizComponentContainer = styled.div`
  max-width: 1200px;
  height: 100%;
  @media (max-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    height: initial;
  }
`;

export const SectionDescription = styled.div`
  display: flex;
  justify-content: column;
  color: ${(props) => props.theme.color.text};
  align-items: center;
  margin: 1em;
`;

export const ResultTitle = styled.h2`
  color: ${(props) => props.theme.color.text};
  hyphens: auto;
`;

export const FinalQuizResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FinalQuizAnswersCountContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  box-shadow: 0px 0px 9px 2px rgba(0, 0, 0, 0.2);
  padding: 1em;
  border-radius: 1em;
  background-color: #fff;
  color: ${(props) => props.theme.color.text};
  font-size: x-large;
  white-space: pre-line;
  margin-bottom: 2em;
`;

interface ButtonFinalQuizResultsProps {
  secondary?: boolean;
}
export const ButtonFinalQuizResults = styled(ButtonPill)<ButtonFinalQuizResultsProps>`
  margin: 1em;
  height: 2.6em;
  ${(props) =>
    props.secondary
      ? `
  background-color: #FFFFFF;
  color: ${props.theme.color.text};
  `
      : ""};
`;

export const ResultCorrectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
export const ResultCorrectionItemContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
